module.exports = __webpack_public_path__ + "1ff0892c9ec000e766531b0b942cd7b2.pdf";